var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable import/no-cycle,consistent-return,default-case */
import React from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import { Accordion } from '@empiriecom/module-components/Accordion';
import cuid from 'cuid';
import filterTimeControl from '../../utils/filterTimeControl';
import Collapse from '../CustomCollapse';
import Wrapper from './Wrapper';
import { accordionTheme } from './theme';
import ComponentRecognizer from '../ComponentRecognizer';
var CustomAccordion = function (_a) {
    var contentData = _a.contentData, styleType = _a.styleType, _b = _a.componentKey, componentKey = _b === void 0 ? cuid() : _b, theme = _a.theme, props = __rest(_a, ["contentData", "styleType", "componentKey", "theme"]);
    var currentStyleType = contentData.field_style_type || styleType;
    return (React.createElement(ThemeProvider, { theme: accordionTheme },
        React.createElement(Wrapper, { styleMargin: contentData.field_margin, styleType: currentStyleType, key: "custom-accordion-wrapper-" + componentKey },
            React.createElement(Accordion, __assign({ key: "custom-accordion-" + componentKey }, props), (contentData === null || contentData === void 0 ? void 0 : contentData.paragraph) &&
                contentData.paragraph
                    .filter(function (item) { return filterTimeControl(item); })
                    .map(function (item) {
                    var content = item.field_html_editor ? (React.createElement("span", { 
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: { __html: item.field_html_editor } })) : (React.createElement(ComponentRecognizer, { content: item.paragraph, key: cuid() }));
                    return (React.createElement(Collapse, { key: "custom-collapse-" + item.id, headline: item.field_headline, id: item.id, styleType: currentStyleType, initialIsOpen: item.field_is_open }, content));
                })))));
};
export default withTheme(CustomAccordion);
//# sourceMappingURL=index.js.map